import moment from 'moment';
import { subTopicSupport, typesSupportOccorence, typeSubjectOccorence } from '../../../constants';
import { tasOccurrence } from '../../../types';
import { ContentLoader } from '@rio-cloud/rio-uikit';
import { convertMinutesToHours } from '../../../components/BoardItem';
interface Props {
    subject?: string;
    supportType?: string;
    createdBy?: string;
    createdAt?: string;
    updatedAt?: string;
    timeInStatus?: string | number;
    statusUpdatedAt?: string;
    isLoading: boolean;
    subtopic?: string;
}

const Label = ({ children }: { children: string }) => {
    return (
        <span className="text-size-14 text-color-dark">{children}</span>
    )
};

const Value = ({ children }: { children?: string | number }) => {
    return (
        <span className="text-size-16 text-color-darker" style={{textAlign: 'right'}}>{children || '-'}</span>
    )
};

const CardInfo = ({ subject, supportType, createdBy, createdAt, updatedAt, timeInStatus, statusUpdatedAt, isLoading, subtopic }: Props) => {
    const style = { display: 'flex', alignItems: 'center', justifyContent: 'space-between' };

    return (
        <div className="border padding-15 display-flex flex-column rounded height-100pct justify-content-between">
            <div>
                <span className="text-medium text-size-16">Informações</span>
            </div>
            <div className="width-100pct" style={style}>
                <Label>Tipo de suporte</Label>
                {isLoading ? (
                    <ContentLoader className='max-width-100' />
                ) : (
                    <Value>{typesSupportOccorence[supportType as keyof typeof typesSupportOccorence]}</Value>
                )}
            </div>
            
            <div className="width-100pct" style={style}>
                <Label>Assunto</Label>
                {isLoading ? (
                    <ContentLoader className='max-width-100' />
                ) : (
                    <Value>{typeSubjectOccorence[subject as keyof typeof typeSubjectOccorence]}</Value>
                )}
            </div>
            
            
            {supportType !== 'CONTRACT_CANCELLATION' && supportType !== 'COMMERCIAL' ? (
                <div className="width-100pct" style={style}>
                    <Label>Tema</Label>
                    {isLoading ? (
                        <ContentLoader className='max-width-100' />
                    ) : (
                        <Value>{subTopicSupport[subtopic as keyof typeof subTopicSupport]}</Value>
                    )}
                </div>
            ) : null}

            <div className="width-100pct" style={style}>
                <Label>Criado por</Label>
                {isLoading ? (
                    <ContentLoader className='max-width-100' />
                ) : (
                    <Value>{createdBy}</Value>
                )}
            </div>
            <div className="width-100pct" style={style}>
                <Label>Data de criação</Label>
                {isLoading ? (
                    <ContentLoader className='max-width-100' />
                ) : (
                    <Value>{moment.utc(createdAt).local().format('DD/MM/YYYY HH:mm')}</Value>
                )}
            </div>
            <div className="width-100pct" style={style}>
                <Label>Ultima atualização</Label>
                {isLoading ? (
                    <ContentLoader className='max-width-100' />
                ) : (
                    <Value>{moment.utc(updatedAt).local().format('DD/MM/YYYY HH:mm')}</Value>
                )}
            </div>
            <div className="width-100pct" style={style}>
                <Label>Tempo na etapa</Label>
                {isLoading ? (
                    <ContentLoader className='max-width-100' />
                ) : (
                    <Value>{convertMinutesToHours(Number(timeInStatus))}</Value>
                )}
            </div>
        </div>
    )
};

export default CardInfo